import type { DynamicAttribute } from '../types/oneGraphTypes';
import type { IconProps } from '@oneaudi/unified-web-components';
import { NON_AUDI_ADDITIONAL_KEYS } from '../constants/nonAudiAdditionalKeys';
import type { CarSpecs } from '../types/nonAudiSpecs';

const getValue = (dynamicAttibutes: DynamicAttribute[], id: string) =>
  dynamicAttibutes.find((item) => item.id === id)?.value ?? '-';

export const parseNonAudiSpecs = (lang: string, dynamicAttibutes?: DynamicAttribute[]) => {
  if (!dynamicAttibutes || !dynamicAttibutes.length) return undefined;
  const listOfData = dynamicAttibutes
    .filter((item) => (lang === 'fr' ? item.id.startsWith('FR-') : !item.id.startsWith('FR-')))
    .filter((item) => NON_AUDI_ADDITIONAL_KEYS.includes(item.id.replace('FR-', '')))
    .map((item) => {
      return {
        ...item,
        id: item.id.replace('FR-', ''),
      };
    }) as DynamicAttribute[];

  const transformedData: CarSpecs = {
    regularSpecs: {
      BODY_STYLE: {
        value: getValue(listOfData, 'BODY_STYLE'),
        iconName: 'traffic' as IconProps['name'],
      },
      EXTERIOR_COLOR_GENERIC: {
        value: getValue(listOfData, 'EXTERIOR_COLOR_GENERIC'),
        iconName: 'brush' as IconProps['name'],
      },
      INTERIOR_COLOR: {
        value: getValue(listOfData, 'INTERIOR_COLOR'),
        iconName: 'brush' as IconProps['name'],
      },
      INTERIOR_MATERIAL: {
        value: getValue(listOfData, 'INTERIOR_MATERIAL'),
        iconName: 'interior-configuration' as IconProps['name'],
      },
      ENGINE: {
        value: getValue(listOfData, 'ENGINE'),
        iconName: 'engine' as IconProps['name'],
      },
      ENGINE_CYLINDERS: {
        value: getValue(listOfData, 'ENGINE_CYLINDERS'),
        iconName: 'engine' as IconProps['name'],
      },
      DRIVE_TRAIN: {
        value: getValue(listOfData, 'DRIVE_TRAIN'),
        iconName: 'quattro' as IconProps['name'],
      },
      TRANSMISSION: {
        value: getValue(listOfData, 'TRANSMISSION'),
        amount: getValue(listOfData, 'TRANSMISSION_SPEED'),
        iconName: 'transmission' as IconProps['name'],
      },
      FUEL_TYPE: {
        value: getValue(listOfData, 'FUEL_TYPE'),
        iconName: 'fuel-station' as IconProps['name'],
      },
    },
    MPG: {
      highway: getValue(listOfData, 'MPG_HWY'),
      city: getValue(listOfData, 'MPG_CITY'),
      combined: getValue(listOfData, 'MPG_COMBINED'),
    },
  };
  return transformedData;
};
